<template>
  <!-- Start Header Area -->
  <header
    id="header"
    :class="['headroom', colored ? 'nav-colored' : 'nav-transparent']"
    style="background-color: green"
  >
    <div class="startp-nav">
      <div class="container">
        <nav class="navbar navbar-expand-md navbar-light ">
          <router-link class="navbar-brand" to="/" tag="li">
            <h4 class="nav-item">
              D3rriana
            </h4>
          </router-link>
          <span class="hamburger" @click="expandNav = !expandNav">
            <svg
              width="30"
              height="31"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 8.20776V6.20776H21V8.20776H3Z"
                :fill="colored ? '#FE828C' : 'black'"
              />
              <path
                d="M3 13.2078H21V11.2078H3V13.2078Z"
                :fill="colored ? '#FE828C' : 'black'"
              />
              <path
                d="M3 18.2078H21V16.2078H3V18.2078Z"
                :fill="colored ? '#FE828C' : 'black'"
              />
            </svg>
          </span>
          <div
            class="d-flex justify-content-center w-100 nav-convertable"
            :class="{ expanded: expandNav }"
          >
            <div v-if="false" class="nav-item" @click="handleHomeClick">
              Home
            </div>
            <div
              v-if="!config.isBeta"
              class="nav-item"
              @click="handleAboutClick"
            >
              About
            </div>
            <div
              v-if="!config.isBeta"
              class="nav-item"
              @click="handleDiscoverClick"
            >
              Discover MyApps
            </div>
            <div
              v-if="!config.isBeta"
              class="nav-item"
              @click="handleResourcesClick"
            >
              Resources
            </div>
            <div v-if="config.isBeta" class="nav-item" @click="handleBlogClick">
              My Blog
            </div>
            <div
              v-if="config.isBeta"
              class="nav-item"
              @click="handleMemoriesClick"
            >
              Our Memories
            </div>
            <div
              v-if="config.isBeta"
              class="nav-item"
              @click="handleFavesClick"
            >
              Tink's Faves
            </div>
            <div
              v-if="config.isBeta"
              class="nav-item"
              @click="handleCreditsClick"
            >
              Thank You
            </div>
            <div
              v-if="!config.isBeta"
              class="nav-item"
              @click="handlePlansClick"
            >
              Pricing
            </div>
          </div>
          <div
            v-if="!config.isBeta && !userLoggedIn"
            class="others-option ml-auto"
          >
            <a
              @click="handleSignIn"
              class="btn"
              style="-webkit-box-shadow: none;-moz-box-shadow: none;box-shadow: none;"
            >
              Sign In
            </a>
            <a
              v-if="!config.isBeta"
              @click="handleSignUp"
              class="btn btn-round-fill"
            >
              Sign Up For Free
            </a>
          </div>
          <div
            class="actions d-flex justify-content-around align-items-center ml-auto"
            v-if="userLoggedIn"
          >
            <div class="nav-item goto-app" @click="handleGotoAppClick">
              Platform
            </div>
            <div class="profile">
              <div
                @click="profilePanel = !profilePanel"
                class="d-flex align-items-center"
              >
                <img
                  v-if="user.photoURL"
                  class="avatar"
                  :src="user.photoURL"
                  :alt="getFirstName(user.displayName)"
                />
                <b-avatar
                  v-else
                  class="avatar"
                  :text="getFirstName(user.displayName)"
                />
                <span class="username">
                  {{ getFirstName(user.displayName) }}
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M3.52876 5.52861C3.78911 5.26826 4.21122 5.26826 4.47157 5.52861L8.00016 9.0572L11.5288 5.52861C11.7891 5.26826 12.2112 5.26826 12.4716 5.52861C12.7319 5.78896 12.7319 6.21107 12.4716 6.47141L8.47157 10.4714C8.21122 10.7318 7.78911 10.7318 7.52876 10.4714L3.52876 6.47141C3.26841 6.21107 3.26841 5.78896 3.52876 5.52861Z"
                      fill="#000000"
                    />
                  </svg>
                </span>
              </div>
              <div
                class="overlay"
                v-if="profilePanel"
                @click="profilePanel = false"
              ></div>
              <transition name="fade">
                <div class="profile-panel" v-if="profilePanel">
                  <ul>
                    <li @click="handleMyAppsClick">
                      <span>MyApps</span>
                    </li>
                    <li @click="handleMyProfileClick">
                      <span>My Profile</span>
                    </li>
                    <li @click="handleMyProfileClick">
                      <span>Pricing</span>
                    </li>
                    <hr />
                    <li class="item logout" @click="signOut">
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M4.58334 3.66659C4.34023 3.66659 4.10707 3.76316 3.93516 3.93507C3.76325 4.10698 3.66668 4.34014 3.66668 4.58325V17.4166C3.66668 17.6597 3.76325 17.8929 3.93516 18.0648C4.10707 18.2367 4.34023 18.3333 4.58334 18.3333H8.25001C8.75627 18.3333 9.16668 18.7437 9.16668 19.2499C9.16668 19.7562 8.75627 20.1666 8.25001 20.1666H4.58334C3.854 20.1666 3.15452 19.8769 2.6388 19.3611C2.12307 18.8454 1.83334 18.1459 1.83334 17.4166V4.58325C1.83334 3.85391 2.12307 3.15443 2.6388 2.63871C3.15452 2.12298 3.854 1.83325 4.58334 1.83325H8.25001C8.75627 1.83325 9.16668 2.24366 9.16668 2.74992C9.16668 3.25618 8.75627 3.66659 8.25001 3.66659H4.58334Z"
                          fill="#EF5C4A"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M14.0185 5.76849C14.3765 5.4105 14.9569 5.4105 15.3148 5.76849L19.8982 10.3518C20.2562 10.7098 20.2562 11.2902 19.8982 11.6482L15.3148 16.2315C14.9569 16.5895 14.3765 16.5895 14.0185 16.2315C13.6605 15.8735 13.6605 15.2931 14.0185 14.9352L17.9536 11L14.0185 7.06485C13.6605 6.70687 13.6605 6.12647 14.0185 5.76849Z"
                          fill="#EF5C4A"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M7.33334 10.9999C7.33334 10.4937 7.74375 10.0833 8.25001 10.0833H19.25C19.7563 10.0833 20.1667 10.4937 20.1667 10.9999C20.1667 11.5062 19.7563 11.9166 19.25 11.9166H8.25001C7.74375 11.9166 7.33334 11.5062 7.33334 10.9999Z"
                          fill="#EF5C4A"
                        />
                      </svg>
                      <span>Sign Out</span>
                    </li>
                  </ul>
                </div>
              </transition>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </header>
  <!-- End Header Area -->
</template>
<script>
import { mapGetters } from "vuex";
import config from "@/assets/_config.json";
export default {
  name: "Header",
  props: {
    isSticky: {
      type: Boolean,
      default: false
    },
    blogHeader: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  computed: {
    ...mapGetters({
      // notifications: "user/listNotifications"
    }),
    ...mapGetters({
      user: "user/user"
    })
  },
  mounted() {
    const myNav = document.getElementById("header");
    window.onscroll = () => {
      "use strict";
      if (window.scrollY >= 200) {
        // myNav.classList.add("nav-colored");
        // myNav.classList.remove("nav-transparent");
        this.colored = true;
      } else {
        // myNav.classList.add("nav-transparent");
        // myNav.classList.remove("nav-colored");
        this.colored = false;
      }
    };
    window.onresize = () => {
      if (window.innerWidth >= 768) {
        this.expandNav = false;
      }
    };
  },
  created() {
    if (this.user) {
      this.userLoggedIn = true;
    }
  },
  watch: {
    user(val) {
      this.userLoggedIn = true;
      return val;
    },
    $route(to, from) {
      const myNav = document.getElementById("header");
      window.onscroll = function() {
        "use strict";
        if (window.scrollY >= 200) {
          myNav.classList.add("nav-colored");
          myNav.classList.remove("nav-transparent");
        } else {
          myNav.classList.add("nav-transparent");
          myNav.classList.remove("nav-colored");
        }
      };
    }
  },
  methods: {
    handleGotoAppClick() {
      this.$router.push("/app");
    },
    handleHomeClick() {
      this.$router.push("/");
    },
    handleAboutClick() {
      this.$router.push("/about-us");
    },
    handleDiscoverClick() {
      this.$router.push("/myapps");
    },
    handleResourcesClick() {
      this.$router.push("/resources");
    },
    handleBlogClick() {
      this.$router.push("/blog");
      this.expandNav = false;
    },
    handleMemoriesClick() {
      this.$router.push("/memories");
      this.expandNav = false;
    },
    handleFavesClick() {
      this.$router.push("/faves");
      this.expandNav = false;
    },
    handleCreditsClick() {
      this.$router.push("/thankyou");
    },
    handlePlansClick() {
      this.$router.push("/pricing");
    },
    handleSignIn() {
      this.$router.push("/signin");
    },
    handleSignUp() {
      this.$router.push("/signup");
    },
    handleMyProfileClick() {
      this.$router.push("/app/profile");
    },
    handleMyAppsClick() {
      this.$router.push("/app");
    },
    signOut() {
      this.$store
        .dispatch("user/signOutAction")
        .then(result => {
          this.$router.push("/signin");
        })
        .catch(err => {
          alert("Oops. " + err.message);
        });
    },
    getInitials(fname, lname) {
      let initials = "";
      if (fname) initials += fname[0];
      if (lname) initials += lname[0];
      return initials;
    },
    getFirstName(fullName) {
      if (fullName) {
        return fullName.split(" ")[0];
      }
      return "";
    }
  },
  data() {
    return {
      config,
      profilePanel: false,
      userLoggedIn: false,
      expandNav: false,
      colored: false
    };
  }
};
</script>

<style lang="scss" scoped>
.btn-round-fill {
  /* identical to box height */
  color: #070707;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.07);
  border-radius: 100px !important;
  border: none;
  &:hover {
    background: #070707 !important;
    color: #ffc729;
  }
}

#header {
  //height: 130px;
  background-color: #fff;

  .collapse--wrapper {
    width: 100%;
  }
  .startp-nav nav {
    padding-bottom: 15px;
  }
  .navbar-brand {
    cursor: pointer;
    margin-right: 0px;
    img {
      height: 60px;
    }
  }
  &.is-sticky {
    padding: 0 !important;
  }
  &.dark {
    .profile-img {
      color: #fff;
    }
  }

  .nav-item {
    cursor: pointer;
    margin-left: 25px;
    transition: color 200ms ease-in-out;
    &.goto-app {
      width: 78px;
    }
    &:hover {
      color: #000;
    }
  }
  &:hover {
    color: #605f59;
  }

  .others-option {
    width: 434px;
    .user {
      display: flex;
      align-items: center;
      img {
        height: 48px;
        width: 48px;
        border-radius: 50%;
        border: 1px #ddd solid;
      }
      .username {
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        color: #52595e;
        margin-left: 14px;
      }
    }
  }
  .blog-nav {
    position: relative;
    height: 58px;
    display: flex;
    align-items: center;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      border-top: 1px solid #dddddd;
    }
    .wrapper--blog-nav {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      .categories {
        display: flex;
        justify-content: center;
        .category {
          transition: 0.3s;
          cursor: pointer;
          &:hover {
            color: #557efb;
          }
          .ico {
            margin-right: 8px;
          }
          margin-right: 32px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
      .blog-links {
        .our-crew,
        .become-blogger {
          font-family: "Nunito", sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 22px;
          color: #52595e;
          &:hover {
            cursor: pointer;
            color: #557efb;
          }
          &:first-child {
            margin-right: 24px;
          }
          &.blogger {
            color: #557efb;
          }
        }
      }
    }
  }
  .actions {
    button,
    div {
      margin: 0 10px;
    }
    button {
      padding: 8px 15px;
      font-size: 16px;
      line-height: 22px;
      height: 44px;
      .text {
        margin-left: 3px;
        vertical-align: middle !important;
      }
    }
    .overlay {
      position: fixed;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      background-color: rgba(189, 189, 189, 0);
      z-index: 8;
    }

    .profile {
      position: relative;
      & > div {
        cursor: pointer;
      }
      .avatar {
        height: 40px;
        width: 40px;
        object-fit: cover;
        border-radius: 50%;
      }
      span {
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        font-family: "Nunito", sans-serif;
        color: #474d52;
        margin-left: 10px;
        display: flex;
        align-items: center;
      }
      .profile-panel {
        z-index: 10;
        position: absolute;
        top: 40px;
        right: -25px;
        background-color: #fff;
        padding: 10px 5px;
        width: 205px;
        box-shadow: 0px 0px 8px 0 #eee;
        border-radius: 10px;

        ul {
          padding: 0;
          list-style-type: none;
          li {
            display: block;
            padding: 8px;
            a {
              font-weight: 700;
              text-decoration: none;
              font-family: "Nunito", sans-serif;

              span {
                font-size: 14px;
                line-height: 19px;
                color: #474d52;
              }
              &:hover {
                background: red;
                box-shadow: none !important;
              }
            }
            &:hover {
              background: #cad0d6;
            }
            &.logout {
              color: red;
            }
          }
          .divider {
            border-top: 1px solid #b3c2cb;
            width: 205px;
            margin-left: -6px;
            margin-top: 10px;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}

/*================================================
Navbar CSS
=================================================*/
#header {
  background-color: #1a4de9;
}
#header.headroom {
  position: fixed; /* position: relative;*/
  width: 100%;
  z-index: 100;
  top: 0;
  left: 0;
  background-color: transparent;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  padding-top: 15px;
}

#header.headroom.is-sticky {
  -webkit-box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.06);
  box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.06);
  background-color: #ffffff !important;
  padding-top: 15px;
  padding-bottom: 15px;
}

#header.headroom.navbar-style-two {
  background-color: #ffffff;
  padding-top: 15px;
  padding-bottom: 15px;
}

#header.headroom--pinned {
  -webkit-transform: translateY(0%);
  transform: translateY(0%);
}

#header.headroom--unpinned {
  -webkit-transform: translateY(-100%);
  transform: translateY(-100%);
  opacity: 0;
  visibility: hidden;
}

.startp-nav {
  background: transparent;
}

.startp-nav nav {
  padding: 0;
}

.startp-nav nav ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
}

.startp-nav nav .navbar-nav .nav-item {
  position: relative;
  padding: 15px 0;
}

.startp-nav nav .navbar-nav .nav-item a {
  font-weight: 500;
  font-size: 15px;
  color: #4a6f8a;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-left: 14px;
  margin-right: 14px;
}

.startp-nav nav .navbar-nav .nav-item a:hover,
.startp-nav nav .navbar-nav .nav-item a:focus,
.startp-nav nav .navbar-nav .nav-item a.active {
  color: #557efb;
}

.startp-nav nav .navbar-nav .nav-item a .feather {
  width: 14px;
  position: relative;
  top: 1.5px;
}

.startp-nav nav .navbar-nav .nav-item .dropdown_menu {
  -webkit-box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.05);
  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.05);
  background: #ffffff;
  position: absolute;
  top: 80px;
  left: 0;
  width: 250px;
  z-index: 99;
  padding-top: 20px;
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 20px;
  opacity: 0;
  border-radius: 5px;
  visibility: hidden;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.startp-nav nav .navbar-nav .nav-item .dropdown_menu li {
  position: relative;
  padding: 0;
}

.startp-nav nav .navbar-nav .nav-item .dropdown_menu li a {
  font-size: 14px;
  font-weight: 500;
  padding: 9px 15px;
  margin: 0;
  display: block;
  color: #4a6f8a;
}

.startp-nav nav .navbar-nav .nav-item .dropdown_menu li a:hover,
.startp-nav nav .navbar-nav .nav-item .dropdown_menu li a:focus,
.startp-nav nav .navbar-nav .nav-item .dropdown_menu li a.active {
  color: #557efb;
}

.startp-nav nav .navbar-nav .nav-item .dropdown_menu li .dropdown_menu {
  position: absolute;
  left: 220px;
  top: 0;
  opacity: 0 !important;
  visibility: hidden !important;
}

.startp-nav nav .navbar-nav .nav-item .dropdown_menu li .dropdown_menu li a {
  color: #4a6f8a;
}

.startp-nav
  nav
  .navbar-nav
  .nav-item
  .dropdown_menu
  li
  .dropdown_menu
  li
  a:hover,
.startp-nav
  nav
  .navbar-nav
  .nav-item
  .dropdown_menu
  li
  .dropdown_menu
  li
  a:focus,
.startp-nav
  nav
  .navbar-nav
  .nav-item
  .dropdown_menu
  li
  .dropdown_menu
  li
  a.active {
  color: #557efb;
}

.startp-nav nav .navbar-nav .nav-item .dropdown_menu li:hover .dropdown_menu {
  opacity: 1 !important;
  visibility: visible !important;
  top: -20px !important;
}

.startp-nav nav .navbar-nav .nav-item .dropdown_menu li:hover a {
  color: #557efb;
}

.startp-nav nav .navbar-nav .nav-item:hover ul {
  opacity: 1;
  visibility: visible;
  top: 100%;
}

.startp-nav nav .others-option {
  margin-left: 20px;
}

.startp-nav nav .others-option .cart-wrapper-btn {
  position: relative;
  margin-right: 20px;
  top: 4px;
}

.startp-nav nav .others-option .cart-wrapper-btn svg {
  width: 15px;
}

.startp-nav nav .others-option .cart-wrapper-btn span {
  display: inline-block;
  background-color: red;
  color: #ffffff;
  font-size: 9px;
  width: 13px;
  height: 13px;
  text-align: center;
  line-height: 14px;
  border-radius: 50%;
  position: relative;
  top: -7px;
  right: 4px;
}

.startp-nav nav .others-option .btn.btn-light {
  background: transparent;
  border: 2px dashed #cdf1d8;
  padding: 12px 33px;
  margin-right: 10px;
}

.startp-nav nav .others-option .btn.btn-light:focus {
  color: #0e314c !important;
}

.startp-nav nav .others-option .btn.btn-light:hover,
.startp-nav nav .others-option .btn.btn-light:focus {
  color: #ffffff;
  border-color: #557efb;
}

.startp-nav nav .others-option .btn.btn-light::after,
.startp-nav nav .others-option .btn.btn-light::before {
  background: #557efb;
}

.startp-nav nav .others-option .btn.btn-primary {
  background: #557efb;
  -webkit-box-shadow: 0 13px 27px 0 rgba(198, 121, 227, 0.25);
  box-shadow: 0 13px 27px 0 rgba(198, 121, 227, 0.25);
}

.startp-nav nav .others-option .btn.btn-primary::after,
.startp-nav nav .others-option .btn.btn-primary::before {
  background: #557efb;
  -webkit-box-shadow: 0 13px 27px 0 #557efb;
  box-shadow: 0 13px 27px 0 #557efb;
}

.navbar-style-three .startp-nav {
  padding-left: 25px;
  padding-right: 25px;
}
.hamburger {
  position: absolute;
  top: 8px;
  right: 0;
  cursor: pointer;
  display: none;
}
@media only screen and (max-width: 767px) {
  .startp-nav .navbar-toggler {
    outline: 0;
    border-color: #0e314c;
    border-radius: 0;
  }
  .startp-nav .navbar-toggler .navbar-toggler-icon {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(0, 0, 0, 1)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E");
  }
  .startp-nav nav .others-option {
    display: none;
  }
  .startp-nav nav .navbar-nav {
    margin-left: 0;
    background-color: #ffffff;
    border: 1px solid #eeeeee;
    margin-top: 15px;
    height: 350px;
    display: block;
    overflow-y: scroll;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .startp-nav nav .navbar-nav .nav-item {
    padding: 10px 0;
  }
  .startp-nav nav .navbar-nav .nav-item a {
    margin-left: 0;
    margin-right: 0;
  }
  .startp-nav nav .navbar-nav .nav-item .dropdown_menu {
    position: relative;
    top: 0;
    -webkit-box-shadow: unset;
    box-shadow: unset;
    left: 0;
    width: 100%;
    opacity: 1;
    visibility: visible;
    border: 1px solid #eeeeee;
    border-radius: 0;
    margin-top: 15px;
    padding-top: 10px;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 10px;
  }
  .startp-nav nav .navbar-nav .nav-item .dropdown_menu li .dropdown_menu {
    position: relative;
    left: 0;
    top: 0;
    opacity: 1 !important;
    visibility: visible !important;
    margin-top: 0;
    margin-left: 11px;
  }
  .startp-nav nav .navbar-nav .nav-item .dropdown_menu li:hover .dropdown_menu {
    top: 0px !important;
  }
  .startp-nav nav .navbar-nav .nav-item:hover ul {
    top: 0;
  }
  .navbar-style-three .startp-nav {
    padding-left: 0;
    padding-right: 0;
  }
  .hamburger {
    display: block;
  }
  .nav-convertable {
    position: absolute;
    top: 48px;
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 0;
    transition: height 200ms ease-in-out;
    overflow: hidden;
    padding: 0 20px;
    /* From https://css.glass */
    background: rgba(255, 255, 255, 0.19);
    border-radius: 6px;
    box-shadow: 0px 8px 11px rgb(0 0 0 / 10%);
    backdrop-filter: blur(4.2px);
    -webkit-backdrop-filter: blur(4.2px);
    .nav-item {
      margin-left: 0 !important;
      margin-bottom: 12px;
    }
    &.expanded {
      height: 138px;
    }
  }
  .nav-colored {
    .nav-convertable {
      top: 58px;
      background: rgba(0, 0, 0, 0.5);
      .nav-item {
        color: #fff !important;
      }
    }
  }
}
@media (max-width: 768px) {
  .actions {
    margin-right: 30px;
    .goto-app {
      margin-top: 4px !important;
    }
    button {
      width: unset !important;
      .text {
        display: none;
      }
    }

    .username {
      display: none !important;
    }
  }
}

@media (max-width: 558px) {
  .actions button,
  .actions div {
    margin: 0 4px;
  }
  .actions button {
    padding: 4px 10px;
  }
  .actions .notification {
    /*position: unset;*/
    .notifications-panel {
      position: fixed;
      width: 100%;
      right: 0;
      left: 0;
      top: 60px;
      bottom: 0;
    }
  }
  .actions .profile .profile-panel {
    right: 0;
  }
}
.nav-colored {
  background-color: #000000 !important;
}
.nav-colored .nav-item {
  color: #fe828c !important;
}
.nav-colored .others-option a {
  color: #fe828c !important;
}
.nav-colored .actions {
  color: #fe828c !important;
}
.nav-colored .navbar-brand path {
  fill: #fe828c !important;
}
.nav-colored .username {
  color: #fe828c !important;
}
.nav-colored .username path {
  fill: #fe828c !important;
}
.nav-transparent {
  background-color: transparent !important;
}
</style>
